import DOMPurify from "dompurify";

export const Badge = (text: string) => {
  const BadgeElement = document.createElement("span");
  BadgeElement.className = "bg-blue-500/10 px-2 py-1 rounded-md";

  BadgeElement.innerHTML = DOMPurify.sanitize(/* html */ `
        <p class="text-blue-500 text-sm font-medium">${text}</p>
    `);

  return BadgeElement;
};
